class ConfigRepo {
  constructor(env: any) {
    this.setDefaultValues(env);
  }

  public SCHEDULE_API_BASE_URI!: string;

  public PUBLISH_API_BASE_URI!: string;

  public CRAWLER_API_BASE_URI!: string;

  public AUTH_API_BASE_URI!: string;

  public ACCEPTED_STATUS_ID!: number;

  public REJECTED_STATUS_ID!: number;

  public PREPUBLISHED_STATUS_ID!: string;

  public PUBLISHED_STATUS_ID!: string;

  public APP_URL!: string;

  private setDefaultValues(env: any): void {
    Object.keys(this).forEach((key) => {
      (this as any)[key] = env[`REACT_APP_${key}`];
    });
  }
}

export { ConfigRepo };
